export default {
  title: 'Guaranteed Ride',
  guaranteedRideHome: 'Guaranteed Ride Home',
  rideRemaining: 'ride remaining until',
  ridesRemaining: 'rides remaining until',
  requestRide: 'Request Ride',
  recentPasses: 'Recent Passes',
  noRecentPasses: 'No recent passes',
  used: 'Used',
  expired: 'Expired',
  openLyft: 'Open Lyft',
  requestingRideCreates: 'Requesting a ride creates a',
  lyftPass: 'Lyft Pass',
  inYourApp: 'in your Lyft app:',
  activePassMessage: 'You have an active pass on Lyft.',
  noAccount: "Don't have a Lyft account?",
  download: 'Download',
  andRegister: 'and register now.',
  infoBox: {
    usableFor: 'Usable for Lyft Standard or Lyft XL',
    coversUpTo: 'Covers up to $250 (incl. 20% tip)',
    validOnlyFor: 'Valid only for trips within the {country}',
  },
  verificationCode: {
    title: 'Verification Code',
    description: 'Verify the phone number associated with your Lyft account so we can create your Lyft Pass.',
    instruction: 'Enter the 4-digit verification code sent to your phone number.',
    placeholder: 'Verification code',
    resendIn: "Didn't receive the code? Resend in {seconds} seconds.",
    didntReceive: "Didn't receive the code?",
    send: 'Send',
    requestNew: 'Request a new one',
  },
  lyftPhone: {
    title: 'Phone Number Associated with Your Lyft Account',
    description: 'To request a Guaranteed Ride, please confirm the phone number associated with your Lyft account.',
    placeholder: 'Phone Number',
    noAccount: "Don't have a Lyft account?",
    download: 'Download',
    registerNow: 'it on your phone and register now.',
    alternative:
      'Alternatively, you can submit your number now and create a Lyft account with that number later. Your Lyft Pass will automatically be created in your account.',
    confirmNumber: 'Confirm Number',
  },
  errors: {
    somethingWentWrong: 'Something went wrong. Please try again.',
    incorrectCode: 'Incorrect verification code. Please try again.',
  },
  success: {
    passCreated: 'Lyft Pass created successfully',
    codeSent: 'Verification code sent successfully',
  },
};
